// $FlowFixMe
import useAlarms from "hooks/useAlarms";
import React, { useEffect } from "react";

export default function withHook(Component: any) {
  // eslint-disable-next-line react/display-name
  return (props: any) => {
    const { updateAlarm, refreshAlarms, allAlarms } = useAlarms();

    useEffect(() => {
      if (!allAlarms) {
        refreshAlarms();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Component updateAlarm={updateAlarm} {...props} />;
  };
}
